export const ApiConfig = {
    media: {
        get: '/media',
        getById: '/media/{id}',
        add: '/media',
        archive: '/media/{id}/archive',
        delete: '/media/{id}',
        getUsage: '/usage',
        restore: '/media/{id}/restore',
        getStatus: '/media/status',
    },
    info: {
        getByMediaId: '/media/{id}/info',
        getById: '/media/{mediaId}/info/{id}',
        add: '/media/{mediaId}/info',
        update: '/media/{mediaId}/info/{id}',
        delete: '/media/{mediaId}/info/{id}',
        getInfographic: '/media/{mediaId}/info/{id}/infographic',
        getSummary: '/media/{mediaId}/info/{id}/summary',
        checkSpelling: '/spelling',
    },
    prompt: {
        post: "/prompt"
    }
}